import Firebase from 'firebase/app'
import { initializeApp } from 'firebase'
import 'firebase/firestore'

const app = initializeApp({
  apiKey: "AIzaSyDkE9xGfBppuef710kCXMwXPTwjR4x0vCM",
  authDomain: "cadastro-39152.firebaseapp.com",
  databaseURL: "https://cadastro-39152.firebaseio.com",
  projectId: "cadastro-39152",
  storageBucket: "cadastro-39152.appspot.com",
  messagingSenderId: "141319983312",
  appId: "1:141319983312:web:b8d8a59efec4f413720ed5"
}, 'cadastro')

const dbCadastro = app.firestore()
const auth = app.auth()
const googleProvider = new Firebase.auth.GoogleAuthProvider()
const facebookProvider = new Firebase.auth.FacebookAuthProvider()
auth.languageCode = 'pt'
export { auth, dbCadastro, app, googleProvider, facebookProvider }



// WEBPACK FOOTER //
// ./src/firebase_cadastro.js